import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import pluralize from 'rebook/apps/utils/text/pluralize';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';
import * as RightholderBookListActions from 'rebook/apps/catalog/actions/RightholderBookListActions';

import styles from './style.scss';


class RightholderBooksView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(RightholderBookListActions.fetchInitialData(match, null));
  }

  constructor(props) {
    super(props);
    const rightholder = get(props, 'location.state.rightholder', null);
    this.state = {
      rightholder,
    };
  }

  componentDidMount() {
    const { match, location, rightholderBookList } = this.props;
    const { booklist } = rightholderBookList;
    if (!booklist) {
      this.props.RightholderBookListActions.fetchInitialData(match, location);
    }
  }

  componentDidUpdate(prevState) {
    const { match, location, rightholderBookList } = this.props;
    const { rightholder: prevrightholder } = prevState.rightholderBookList;
    const { rightholder, booklist } = rightholderBookList;
    const prevrightholderId = get(prevrightholder, 'id', null);
    const currentRightholderId = get(rightholder, 'id', null);
    const isRedirected = prevrightholderId || !this.state.rightholder;

    if (currentRightholderId !== prevrightholderId && !booklist && isRedirected) {
      this.props.RightholderBookListActions.fetchInitialData(match, location);
    }
  }

  changeOrderBy(orderBy) {
    this.props.RightholderBookListActions.fetchBookList({ orderBy, pageNumber: 1 });
  }

  filterBySubscriptionType(subscriptionId) {
    this.props.RightholderBookListActions.fetchBookList({ subscriptionId, pageNumber: 1 });
  }

  changeBookType(bookType) {
    this.props.RightholderBookListActions.fetchBookList({ bookType, pageNumber: 1 });
  }

  resetFilters() {
    this.props.RightholderBookListActions.fetchBookList({
      subscriptionId: null,
      bookType: null,
      orderBy: null,
      pageNumber: 1,
    });
  }

  changePage(pageNumber) {
    this.props.RightholderBookListActions.fetchBookList({ pageNumber });
  }

  render() {
    const {
      rightholder, bookList, orderBy,
      subscriptionId, bookType, totalBookCount,
      lastPageNumber, pageNumber,
    } = this.props.rightholderBookList;

    let bookCount = get(rightholder, 'counters.books', 0) || get(rightholder, 'active_book_count', 0);

    if (orderBy !== 'popular' || subscriptionId || bookType) {
      bookCount = totalBookCount;
    }

    return (
      <div>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/books/' },
            { text: get(rightholder, 'name', ''), url: '' },
          ]} />
          <div className="sectionHeader">
            {rightholder && rightholder.name
              ? (
                <h1>Издатель &laquo;{rightholder.name}&raquo;</h1>
              )
              : (
                <h1>Издатель</h1>
              )
            }
          </div>
          {!!bookCount && (
            <div className={styles.count}>
              {bookCount}&nbsp;{`${pluralize(bookCount, 'книга', 'книги', 'книг')}`}
            </div>
          )}
          {bookList &&
            <div className={styles.filters}>
              <CatalogFilter
                orderBy={orderBy}
                subscriptionId={subscriptionId}
                bookType={bookType}
                isResultEmpty={bookList && bookList.length === 0}
                onChangeOrder={(value) => this.changeOrderBy(value)}
                onChangeSubscription={(value) => this.filterBySubscriptionType(value)}
                onChangeBookType={((value) => this.changeBookType(value))}
                onResetFilter={()=>this.resetFilters()} />
            </div>
          }
          {(bookList && bookList.length > 0) && (
            <BookList books={bookList} />
          )}
          {(bookList === null) && (
            <BookList books={[...Array(5)]} />
          )}
          {(bookList && bookList.length === 0) && (
            <EmptyFilterResult />
          )}
          {(lastPageNumber > 1 && bookList && bookList.length > 0) && (
            <ContextPagination
              extraClassName="jest-rightholder-book-list-pagination"
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    rightholderBookList: state.rightholderBookList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    RightholderBookListActions: bindActionCreators(RightholderBookListActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RightholderBooksView);
